import React, {Component} from "react";
import {Button, Col, Modal, Row, Tab, Tabs} from "react-bootstrap";
import "./SingleCustomerComp.css";
import {connect} from "react-redux";
import {alertActions} from "../../store/actions/AlertActions";
import BasicDataComp from "./basicData/BasicDataComp";
import registerUserRequest from "./requests/registerUserRequest";
import getCustomer from "./requests/getCustomer";
import CustomerDocumentComp from "./document/CustomerDocumentComp";
import QuestionnaireForm from "./questionnaire/QuestionnaireForm";
import CustomerQuestionnaires from "./questionnaire/CustomerQuestionnaires";
import {QUESTIONNAIRE_TYPES} from "./questionnaire/questionnaireDefinitions";
import {Header, Loading, PageContainer} from "../../genericComponents";
import {location} from "../../utils";

function renderTabContent(eventKey, title, disabled, children) {
  return (
    <Tab eventKey={eventKey} title={title} disabled={disabled} className="mt-3">
      <Row>
        <Col>
          <h6 className="is-required">
            Campos marcados com * são obrigatórios o preenchimento
          </h6>
        </Col>
      </Row>
      {children}
    </Tab>
  );
}

/**
 * Cadastro/edição de cliente.
 * - Cadastro (sem id): dados básicos → questionário (tipo pela categoria da rota) → cadastra tudo junto.
 * - Edição (com id): dados básicos salvam sozinhos; a aba Questionários gerencia vários questionários.
 */
class SingleCustomerComp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabKey: "BasicData",
      customerId: null,
      basicData: null,
      questionnaire: null,
      serverData: null,
      isFetchingData: Boolean(props.id),
      isFetching: false,
      registerFeedback: null,
    };
  }

  componentDidMount = () => {
    const {id} = this.props;
    if (id !== undefined) {
      getCustomer(id, (state) => this.setState(state));
    }
  };

  handleSelectTab = (tabKey) => {
    this.setState({tabKey});
  };

  /** Tipo do questionário no cadastro, pela categoria da rota (/cliente/:category/...). */
  getRegisterType = () =>
    this.props.category?.includes("pensao") ? QUESTIONNAIRE_TYPES.PENSAO : QUESTIONNAIRE_TYPES.APOSENTADORIA;

  setBasicData = (basicData) => {
    if (this.props.id) {
      this.setState({basicData}, this.registerUser);
      return;
    }
    const ready = Boolean(this.state.questionnaire);
    this.setState(
      (state) => ({basicData, tabKey: ready ? state.tabKey : "Survey"}),
      ready ? this.registerUser : null
    );
  };

  setQuestionnaire = (answers) => {
    const questionnaire = {type: this.getRegisterType(), answers};
    if (!this.state.basicData) {
      this.props.onAddAlert("Confirme os dados básicos para concluir o cadastro.", "warning");
      this.setState({questionnaire, tabKey: "BasicData"});
      return;
    }
    this.setState({questionnaire}, this.registerUser);
  };

  registerUser = () => {
    if (!this.state.isFetching) {
      this.setState({isFetching: true}, () =>
        registerUserRequest(this.props, this.state, (registerFeedback) => {
          this.setState({isFetching: false, registerFeedback});
        })
      );
    }
  };

  getDisabledField = () => {
    const {from, id, privileges} = this.props;
    if (from === "login" || from === "processo") return false;
    if (from === "clientes") {
      if (Boolean(id)) {
        if (privileges?.clientes?.update) return false;
      } else if (privileges?.clientes?.create) return false;
    }
    return true;
  };

  renderQuestionnaireTab = (disabledField) => {
    const {id, from} = this.props;
    if (id) {
      return this.state.customerId ? (
        <CustomerQuestionnaires
          customerId={this.state.customerId}
          disabled={disabledField}
          canDelete={from === "clientes"}
        />
      ) : null;
    }
    return (
      <QuestionnaireForm
        type={this.getRegisterType()}
        initialAnswers={this.state.questionnaire?.answers}
        disabled={disabledField}
        requireTerm
        submitLabel="Cadastrar"
        onSubmit={this.setQuestionnaire}
      />
    );
  };

  render() {
    const {registerFeedback, isFetchingData, isFetching} = this.state;
    const {id, from} = this.props;

    const disabledField = this.getDisabledField();

    return (
      <Loading
        loading={isFetchingData || isFetching}
        loadingText={isFetchingData ? null : "Carregando..."}
      >
        <Modal show={Boolean(registerFeedback)} centered>
          <Modal.Header>
            <Modal.Title>
              {id ? "Atualização concluída" : "Cadastro concluído"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>{registerFeedback}</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                if (from === "login") {
                  window.location.href = "/";
                } else if (from === "clientes" && !id) {
                  window.location.href = "/clientes";
                } else {
                  this.setState({registerFeedback: null});
                }
              }}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
        <Header
          logged={from !== "login"}
          navigation={[
            {
              href: from === "login" ? "/" : "/clientes",
              label: from === "login" ? "Login" : "Clientes",
            },
          ]}
          active={
            from === "login" || !id
              ? "Cadastro"
              : this.state?.serverData?.fullname
          }
        />
        <PageContainer fixedHeight className="p-3">
          <div className="h-100 overflow-hidden d-flex flex-column">
            <Tabs
              activeKey={this.state.tabKey}
              onSelect={this.handleSelectTab}
            >
              {renderTabContent(
                "BasicData",
                "Dados básicos",
                false,
                <BasicDataComp
                  id={id}
                  serverData={this.state.serverData}
                  setInfos={this.setBasicData}
                  invalidateInfos={() => {
                    if (!id && this.state.basicData) {
                      this.setState({basicData: null});
                    }
                  }}
                  setRef={() => null}
                  states={location.states}
                  allCitiesFromStates={location.allCitiesFromStates}
                  disabledField={disabledField}
                />
              )}
              {renderTabContent(
                "Survey",
                id ? "Questionários" : "Questionário",
                !id && !this.state.basicData,
                <div className="overflow-fix">{this.renderQuestionnaireTab(disabledField)}</div>
              )}
              {from === "clientes" && id && (
                <Tab
                  eventKey="documents"
                  title="Documentos"
                  disabled={false}
                  className="mt-3 h-100"
                >
                  <div className="h-100 d-flex flex-column">
                    <CustomerDocumentComp id={id}/>
                  </div>
                </Tab>
              )}
            </Tabs>
          </div>
        </PageContainer>
      </Loading>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddAlert: (text, alertType, alertPriority) =>
      dispatch(alertActions.addAlert(text, alertType, alertPriority)),
  };
};

export default connect(null, mapDispatchToProps)(SingleCustomerComp);
